module.exports = __webpack_public_path__ + "static/media/15_fnbasia.6b02f630.svg";